import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageContainer = styled.div`
  position: relative;
  cursor: pointer;
  margin: 0 1rem;
`;

const FlagImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  transition: transform 0.3s ease;
`;

const PopupContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 0.5rem;
  margin-top: 0.5rem;
  display: ${props => props.show ? 'block' : 'none'};
  z-index: 1000;
`;

const LanguageOption = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  cursor: pointer;
  white-space: nowrap;
  color: #333;
  
  &:hover {
    background-color: #f5f5f5;
    border-radius: 4px;
  }
  
  img {
    margin-right: 8px;
  }
`;

const LanguageSelector = ({ onPopupToggle, isOpen }) => {
  const { language, setLanguage } = useLanguage();
  const containerRef = useRef(null);

  const handleLanguageChange = (newLang) => {
    setLanguage(newLang);
    onPopupToggle();
    localStorage.setItem('preferredLanguage', newLang);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onPopupToggle();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isOpen, onPopupToggle]);

  return (
    <LanguageContainer ref={containerRef}>
      <FlagImage
        src={`https://flagcdn.com/w40/${language === 'en' ? 'us' : 'do'}.png`}
        alt={language === 'en' ? 'English' : 'Español'}
        onClick={onPopupToggle}
      />
      <PopupContainer show={isOpen}>
        <LanguageOption onClick={() => handleLanguageChange('en')}>
          <FlagImage
            src="https://flagcdn.com/w40/us.png"
            alt="English"
          />
          English
        </LanguageOption>
        <LanguageOption onClick={() => handleLanguageChange('es')}>
          <FlagImage
            src="https://flagcdn.com/w40/do.png"
            alt="Español"
          />
          Español
        </LanguageOption>
      </PopupContainer>
    </LanguageContainer>
  );
};

export default LanguageSelector; 